// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1N9e3","title":"AfterBackImages_title__KfFIU","images":"AfterBackImages_images__3xOvH"};